import styled from 'styled-components';
import { COLORS } from 'styles/constants';
import tw from 'tailwind-styled-components';
import { Text as Paragraph, Title } from '../Typography';

export const Container = tw.div`
  overflow-x-hidden
  w-full
  mt-10
  mb-5
  md:mt-20
`;

export const Table = tw.table`
  w-full
`;

export const Tr = tw.tr`
  ${(p: { line?: string }) => (p.line === 'odd' ? 'bg-lightBrown' : '')}
`;

export const Th = tw.th`
  h-16
  text-left
  px-2.5
  md:px-5
  md:h-20
`;

export const Td = tw.td`
  h-16
  px-2.5
  md:px-5
  md:h-20
`;

export const CustomTab = styled.div`
  margin-top: 20px;
  .react-tabs__tab-panel--selected {
    display: inline-block;
  }
  .react-tabs__tab {
    border: 0;
    border-bottom: 3px solid #d4ded3;
    margin: 0;
    padding: 10px 15px;
    white-space: nowrap;
    color: ${COLORS.primary};
    :after {
      width: 4px;
      height: 4px;
      content: '';
      border-radius: 2px;
      background-color: #d4ded3;
      display: inline-block;
      position: absolute;
      left: -5px;
      top: 50%;
    }
    :first-child {
      padding: 10px 15px 10px 0;
      :after {
        content: none;
      }
    }
  }
  .react-tabs__tab-list {
    border: 0;
    margin-bottom: 12px;
    display: flex;
  }
  .react-tabs__tab--selected {
    border-bottom-color: #292b29;
    color: #292b29;
  }
  li {
    width: 100%;
  }
`;

export const ColHeading = tw.div`
  align-top
`;

export const ColHeadList = tw.div`
  p-4
  h-70
  flex
  items-center
  ${(p: { line?: string }) => (p.line === 'odd' ? 'bg-lightBrown' : '')}
`;

export const ColData = tw.div`
  flex
  items-center
  h-70
  p-4
  ${(p: { line?: string }) => (p.line === 'odd' ? 'bg-lightBrown' : '')}
`;

export const Heading = tw(Paragraph)`
  font-normal
  opacity-70
`;

export const Label = tw(Paragraph)`
  font-medium
`;
export const MobileLabel = tw(Paragraph)`
  font-medium
`;

export const MainTitle = tw(Title)`
  text-center
  mb-9
  md:mb-10
`;

export const SubTitle = tw(Paragraph)`
  text-center
  opacity-70
  mb-2.5
  md:mb-5
`;

export const Note = tw(Paragraph)`
  relative
  opacity-70
  -top-3
`;
export const Disclaimer = tw(Paragraph)`
  py-5
`;
